import { startOfToday } from "date-fns";

import { DetailedSource, TicketSilo, TicketStatus as TicketStatusEnum } from "interfaces/entities/ticket";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ITag, TagAuthor } from "store/entities/tags";

import { AgentAssignmentFilterEnum } from "./agent-assignment-filter";
import { AttachmentsFilterEnum } from "./attachments-filter";
import { IDateRangeFilter, IDateRangeWithCompareFilter } from "./date-range-filter";
import { DeliveryStatus } from "./delivery-status-filter";
import { IPriorityFilter } from "./priority-filter";
import { RatingFilter } from "./rating-filter";
import { TagFilter } from "./tag-filter";

export enum Filter {
  Action = "action",
  Agent = "agent",
  AgentAssignment = "agentAssignment",
  Attachments = "hasAttachments",
  Author = "author",
  CreationDateRange = "creationDateRange",
  DateRange = "dateRange",
  Followers = "followers",
  Group = "group",
  Language = "language",
  LastActivityDateRange = "lastActivityDateRange",
  LastMessageDateRange = "lastMessageDateRange",
  Priority = "priority",
  Rating = "rating",
  RatingDateRange = "ratingDateRange",
  RequesterEmail = "requesterEmail",
  ResolutionDateRange = "resolutionDateRange",
  ResponseAuthor = "responseAuthor",
  ResponseDateRange = "responseDateRange",
  Silo = "silo",
  DetailedSource = "detailedSource",
  Tag = "tag",
  Target = "target",
  TicketStatus = "ticketStatus",
  PageSize = "pageSize",
  NextId = "next.ID",
  PrevId = "prev.ID",
  NextValue = "next.value",
  PrevValue = "prev.value",
  DeliveryStatus = "deliveryStatus",
  DeliveryUpdatedAtFrom = "deliveryUpdatedAtFrom",
  DeliveryUpdatedAtTo = "deliveryUpdatedAtTo",
}

export interface IFilters {
  [Filter.Action]?: string;
  [Filter.Agent]?: string[];
  [Filter.AgentAssignment]?: AgentAssignmentFilterEnum[];
  [Filter.Attachments]?: AttachmentsFilterEnum[];
  [Filter.Author]?: string;
  [Filter.CreationDateRange]?: IDateRangeWithCompareFilter;
  [Filter.DateRange]?: IDateRangeWithCompareFilter;
  [Filter.Followers]?: string[];
  [Filter.Group]?: string[];
  [Filter.Language]?: string[];
  [Filter.LastActivityDateRange]?: IDateRangeWithCompareFilter;
  [Filter.LastMessageDateRange]?: IDateRangeWithCompareFilter;
  [Filter.Priority]?: IPriorityFilter;
  [Filter.Rating]?: RatingFilter[];
  [Filter.RatingDateRange]?: IDateRangeFilter;
  [Filter.RequesterEmail]?: string[];
  [Filter.ResolutionDateRange]?: IDateRangeFilter;
  [Filter.ResponseAuthor]?: string[];
  [Filter.ResponseDateRange]?: IDateRangeFilter;
  [Filter.Silo]?: TicketSilo;
  [Filter.DetailedSource]?: DetailedSource[];
  [Filter.Target]?: string;
  [Filter.Tag]?: string[];
  [Filter.TicketStatus]?: TicketStatusEnum[];
  [Filter.PageSize]?: number;
  [Filter.NextId]?: string;
  [Filter.PrevId]?: string;
  [Filter.NextValue]?: string;
  [Filter.PrevValue]?: string;
  [Filter.DeliveryStatus]?: DeliveryStatus[];
  [Filter.DeliveryUpdatedAtFrom]?: string;
  [Filter.DeliveryUpdatedAtTo]?: string;
}

export const NotTaggedFilterId = "not_tagged";

export const notTaggedFilter: ITag = {
  id: NotTaggedFilterId,
  name: TagFilter.NotTagged as string,
  teamId: "NOT_TAGGED_TEAM_ID",
  count: 0,
  createdAt: startOfToday(),
  createdBy: "NOT_TAGGED_AGENT_ID",
  createdByType: "system" as TagAuthor,
  updatedAt: startOfToday(),
  updatedBy: "NOT_TAGGED_AGENT_ID",
};
